export const getPageContentQueryKey = (lookupCode?: string) =>
  ['page-content', lookupCode] as const;
